<template>
  <div class="fileBox">
    <div 
      class="fileItem m-r-8 m-b-8" 
      v-for="(item, index) in tasksItem.fileList" 
      :key="index"
      :class="!isImageFile(item.fileURL || item.fileUrl)?'width-100 cor167CDB':''"
      @click="handleFileClick(item)"
    >
      <!-- 图片文件 -->
      <div 
        v-if="isImageFile(item.fileURL || item.fileUrl)" 
        class="fileContainer"
      >
        <van-image 
          width="80" 
          height="80" 
          fit="cover"
          :src="item.fileURL || item.fileUrl"
        />
      </div>
       <div 
        v-else 
        class=" "
     
      >
         {{ item.fileName }}
      </div>
      <!-- PDF 文件 -->
      <!-- <div 
        v-else-if="isPdfFile(item.fileURL || item.fileUrl)" 
        class=" "
     
      >
      {{ item.fileName }} -->
        <!-- <van-icon name="pdf" size="20" color="#FF0000" class="m-b-2" />
        <div class="font-14 text-ellipsis" style="max-width: 100%;">PDF</div> -->
      <!-- </div> -->
      
      <!-- Word 文档 -->
      <!-- <div 
        v-else-if="isWordFile(item.fileURL || item.fileUrl)" 
        class=" "
     
      >
       {{ item.fileName }} -->
        <!-- <van-icon name="document" size="20" color="#2B579A" class="m-b-2" />
        <div class="font-14 text-ellipsis" style="max-width: 100%;">DOC</div> -->
      <!-- </div> -->
      
      <!-- Excel 文档 -->
      <!-- <div 
        v-else-if="isExcelFile(item.fileURL || item.fileUrl)" 
        class=" "
     
      >
         {{ item.fileName }} -->
        <!-- <van-icon name="orders-o" size="20" color="#217346" class="m-b-2" />
        <div class="font-14 text-ellipsis" style="max-width: 100%;">XLS</div> -->
      <!-- </div> -->
      
      <!-- 其他文件 -->
      <!-- <div 
        v-else 
        class=" "
     
      >
        <van-icon name="more-o" size="20" class="m-b-2" />
        <div class="font-14 text-ellipsis" style="max-width: 100%;">文件</div>
      </div> -->
    </div>
    
    <!-- 图片预览 -->
    <van-image-preview 
      v-model="showImagePreview" 
      :images="currentImageList" 
      :start-position="currentImageIndex"
      @change="onImageChange"
    />
    
    <!-- 移动端PDF预览弹窗 -->
    <van-popup 
      v-model="showPdfPreview" 
       class="filePreviewStyle"
      position="bottom" 
      :style="{ height: '90%', width: '100%', bottom: '0' }" 
      round
      closeable
      @close="closePdfPreview"
    >
    <div class="title font-28  cor-33 p-24 text-center">{{selectedFile?selectedFile.fileName:''}}</div>
    <div class="pdfPreviewContainer">
        <iframe 
          :src="currentPdfUrl" 
          frameborder="0" 
          @load="onPdfLoaded"
        ></iframe>
      </div>
    </van-popup>
    
    <!-- 移动端Office文档预览弹窗 -->
    <van-popup 
      v-model="showOfficePreview" 
       class="filePreviewStyle"
      position="bottom" 
      :style="{ height: '90%', width: '100%', bottom: '0'}" 
      round
      closeable
      @close="closeOfficePreview"
    >
    <div class="title font-28  cor-33 p-24 text-center">{{selectedFile?selectedFile.fileName:''}}</div>
    <div class="officePreviewContainer">
        <iframe 
          :src="currentOfficeUrl" 
          frameborder="0" 
          
        ></iframe>
      </div>
    </van-popup>
    
    <!-- 文件下载确认弹窗 -->
    <van-action-sheet 
      v-model="showDownloadSheet" 
      :actions="downloadActions" 
      @select="onDownloadSelect"
      cancel-text="取消"
    />
  </div>
</template>

<script>
export default {
  name: 'FileComponent',
  props: {
    tasksItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showImagePreview: false,
      showPdfPreview: false,
      showOfficePreview: false,
      showDownloadSheet: false,
      currentImageList: [],
      currentImageIndex: 0,
      currentPdfUrl: '',
      currentOfficeUrl: '',
      currentFile: null,
      selectedFile:null
    }
  },
  computed: {
    downloadActions() {
      return [
        { name: '在浏览器中打开', value: 'open' },
        { name: '下载文件', value: 'download' }
      ];
    }
  },
  methods: {
    // 获取文件扩展名（处理带查询参数的URL）
    getFileExtension(url) {
      if (!url) return '';
      
      // 去掉查询参数部分（?后面的内容）
      const cleanUrl = url.split('?')[0];
      
      // 获取扩展名
      const lastDotIndex = cleanUrl.lastIndexOf('.');
      if (lastDotIndex === -1) return '';
      
      return cleanUrl.substring(lastDotIndex).toLowerCase();
    },
    
    // 判断是否为图片文件
    isImageFile(url) {
      if (!url) return false;
      const ext = this.getFileExtension(url);
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      return imageExtensions.includes(ext);
    },
    
    // 判断是否为PDF文件
    isPdfFile(url) {
      if (!url) return false;
      const ext = this.getFileExtension(url);
      return ext === '.pdf';
    },
    
    // 判断是否为Word文件
    isWordFile(url) {
      if (!url) return false;
      const ext = this.getFileExtension(url);
      const wordExtensions = ['.doc', '.docx'];
      return wordExtensions.includes(ext);
    },
    
    // 判断是否为Excel文件
    isExcelFile(url) {
      if (!url) return false;
      const ext = this.getFileExtension(url);
      const excelExtensions = ['.xls', '.xlsx', '.csv'];
      return excelExtensions.includes(ext);
    },
    
    // 处理文件点击事件
    handleFileClick(item) {
        this.selectedFile = item;
      const fileUrl = item.fileURL || item.fileUrl;
      
      if (this.isImageFile(fileUrl)) {
        // 图片文件 - 预览
        this.previewImage(fileUrl);
      } else if (this.isPdfFile(fileUrl)) {
        // PDF文件 - 移动端优化预览
        this.previewPdf(fileUrl);
      } else if (this.isWordFile(fileUrl) || this.isExcelFile(fileUrl)) {
        // Office文档 - 移动端优化预览
        this.previewOfficeDoc(fileUrl);
      } else {
        // 其他文件 - 弹出操作选项
        this.currentFile = item;
        this.showDownloadSheet = true;
      }
    },
    
    // 预览图片
    previewImage(imgUrl) {
      // 获取当前任务的所有图片URL
      this.currentImageList = this.getAllImageUrls();
      this.currentImageIndex = this.currentImageList.indexOf(imgUrl);
      this.showImagePreview = true;
    },
    
    // 获取当前任务中的所有图片
    getAllImageUrls() {
      if (!this.tasksItem || !this.tasksItem.fileList) return [];
      
      return this.tasksItem.fileList
        .filter(file => this.isImageFile(file.fileURL || file.fileUrl))
        .map(file => file.fileURL || file.fileUrl);
    },
    
    // 预览PDF文件
    previewPdf(pdfUrl) {
      // 使用浏览器内置PDF查看器
      this.currentPdfUrl = pdfUrl;
      this.showPdfPreview = true;
    },
    
    // 预览Office文档
    previewOfficeDoc(docUrl) {
      // 使用微软Office在线预览服务
      const encodedUrl = encodeURIComponent(docUrl);
      this.currentOfficeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
      this.showOfficePreview = true;
    },
    
    // 关闭PDF预览
    closePdfPreview() {
      this.showPdfPreview = false;
      this.currentPdfUrl = '';
    },
    
    // 关闭Office预览
    closeOfficePreview() {
      this.showOfficePreview = false;
      this.currentOfficeUrl = '';
    },
    
    // 图片预览变化回调
    onImageChange(index) {
      this.currentImageIndex = index;
    },
    
    // PDF加载完成回调
    onPdfLoaded() {
      console.log('PDF loaded successfully');
    },
    
    // 下载操作选择
    onDownloadSelect(action) {
      if (action.value === 'download') {
        this.downloadFile(this.currentFile.fileURL || this.currentFile.fileUrl, this.currentFile.fileName);
      } else if (action.value === 'open') {
        window.open(this.currentFile.fileURL || this.currentFile.fileUrl, '_blank');
      }
      this.showDownloadSheet = false;
    },
    
    // 下载文件
    downloadFile(url, fileName) {
      if (!url) return;
      
      // 创建下载链接
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || '下载文件';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style lang="less">
.fileBox {
  display: flex;
  flex-wrap: wrap;
  .cor167CDB{
    color: #167CDB;
  }
  .fileItem{
    cursor: pointer;
    transition: transform 0.2s;
    border-radius: 8px;
    
    &:active {
      transform: scale(0.95);
    }
  }
  
  .fileContainer {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eee;
     width: 100px;
    height: 100px;
  }
  
  .filePlaceholder {
    border: 1px solid #ddd;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    background-color: #f8f9fa;
    
    &:active {
      background-color: #e9ecef;
    }
  }
  
  .pdfPreviewContainer,
  .officePreviewContainer {
    width: 100%;
    height: calc(100% -  100px);
    padding: 16px;
    box-sizing: border-box;
    overflow-y: auto;
    
    iframe {
        border-radius: 8px;
        background: white;
        width:  100%;
        height: calc(100% - 10px);
    }
  }
  .filePreviewStyle{
      .title{
            border: 2px solid #e5e5e5;
            font-weight: bold;
        }
     .van-popup__close-icon--top-right{
      top: 30px;
      right: 24px;
    }
    .van-icon{
      font-size: 32px;
      color: #333;
    }
  }
}
</style>